import { ChevronUpIcon } from '@heroicons/react/outline'
import { ChevronDownIcon } from '@heroicons/react/outline'
import { useState } from 'react'

import { Button, FlexBox } from 'components/common'
import { MenuItem } from 'components/common/NavigationDropdownMenu/NavigationDropdownMenuItem'
import NavigationDropdownMenuItem from 'components/common/NavigationDropdownMenu/NavigationDropdownMenuItem'
import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  menuName: string
  menuItems: MenuItem[]
}

export default function DropdownMenu({ menuName, menuItems }: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    <PDSBox position="relative">
      {/** We should update this to use a new "PDSDropdown" instead */}
      <Button onClick={() => setIsOpen(!isOpen)} variant="tertiary">
        <PDSFlexBox color={COLOR.grey600}>
          <FlexBox flexDirection="column" gap={SIZE.s4} marginRight={SIZE.s8}>
            <PDSText fontSize={FONT_SIZE.fs14} weight="semibold">
              {menuName}
            </PDSText>
          </FlexBox>

          <PDSBox width="1.25rem">
            {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </PDSBox>
        </PDSFlexBox>
        {isOpen && (
          <PDSBox
            backgroundColor={COLOR.white}
            border={`1px solid ${COLOR.grey300}`}
            borderRadius="0.5rem"
            boxShadow={`inset 0 0 1px 1px ${COLOR.grey300}`}
            padding={SIZE.s8}
            position="absolute"
            width="15rem"
            zIndex={2}
          >
            {menuItems.map((item) => {
              return <NavigationDropdownMenuItem key={item.name} item={item} />
            })}
          </PDSBox>
        )}
      </Button>
    </PDSBox>
  )
}
